import React, { useState } from "react";
import axiosInstance from "../../utils/AxiosInstance";
import { toast } from "react-toastify";
import { Typography, Box, Container, TextField, Button } from "@mui/material";
import { useSignIn } from "react-auth-kit";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

const Login = () => {
  const signIn = useSignIn();
  const navigate = useNavigate();
  // const [formData, setFormData] = useState({ username: "", password: "" });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isError, setIsError] = useState(false);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const getHighestRole = (roles) => {
    roles.sort((a, b) => (a.id > b.id ? 1 : -1)); // if b['id'] is smaller than a['id'], b has precedence
    return roles[0]["id"];
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // post request to get a token
    axiosInstance
      .post(`/auth/login`, {
        username,
        password,
      })
      .then((res) => {
        // if login is successfull, redirect to dashboard
        if (res.status === 200) {
          let token = res.data.access_token;

          // get user data
          axiosInstance
            .get(`/users/current`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then((_res) => {
              // obtained current user data
              // now perform the signin (saving data to context)
              const _role = getHighestRole([..._res.data.roles]);
              if (
                signIn({
                  token: token,
                  tokenType: "Bearer",
                  expiresIn: 60,
                  authState: {
                    user: _res.data,
                    role: _role,
                  },
                })
              ) {
                // user is loggedin
                navigate("/");
              }
            })
            .catch((_err) => {
              console.log(
                "There was a problem either getting current user data or signin in"
              );
            });
        } else {
          console.log(
            "Error performing login, probably incorrent username/psw"
          );
        }
      })
      .catch((err) => {
        console.log("Error with request for /auth/login");
        toast.error("Username o password sbagliati");
        setIsError(true);
      });
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Log in
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            onChange={handleUsernameChange}
            fullWidth
            id="username"
            label="Username o indirizzo mail"
            name="username"
            autoFocus
            error={isError}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            onChange={handlePasswordChange}
            error={isError}
            id="password"
          />
          <Link to="/resetpassword">Reset password</Link>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Sign In
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
